import { Component, OnInit } from '@angular/core';
import { EmpresaService } from '../services/empresa.service';
import { Empresa } from '../model/empresa';
import { ActivatedRoute, Router } from '@angular/router';
import { MotorService } from '../services/motor.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {

  public empresa: Empresa = new Empresa()

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly motorService: MotorService,
    private readonly empresaService: EmpresaService,
    private spinnerService: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe( params => {
      this.empresaService.buscarDadosEmpresa(params.get("company")).subscribe( empresa => {
        this.empresa = empresa;
        if ( (this.empresa.nome_fantasia == "") || (this.empresa.nome_fantasia == undefined) ) {
          this.router.navigate(['error']);
        } else {
          this.motorService.changeEmpresa(this.empresa);
        }        
      });
    });    
  }
 
  spinner(): void {
    this.spinnerService.show();
    setTimeout(() =>{
      this.spinnerService.hide();
    }, 2000);
  }
}
